import React, {useState, useEffect, createRef, useRef} from 'react'
import CustomMarker from '../../assets/img/maps/map.png'
import {
  INNER_BOUNDS,
  OUTER_RINGROAD,
  Damak,
  Dharan,
  Dhangadi,
  Baglung,
  Bardaghat,
  Belbari,
  Bhairahawa,
  Bharatpur,
  Biratnagar,
  Birgunj,
  Birtamode,
  Butwal,
  Rajbiraj,
  Gaighat,
  Ghorahi,
  Nepalgunj,
  Hetauda,
  Janakpur,
  Pokhara,
  Siraha,
  Surkhet,
  Tulsipur
} from './constants'
import './GoogleMaps.css'

const Map = ({onClose, onAddressSelected}) => {
  const googleMapRef = createRef()
  const [latlng, setLatlng] = useState({
    lat: 27.704,
    lng: 85.309,
  })
  const [address, setAddress] = useState(null)
  const geoCoderRef = useRef(null)
  const [isUnderFencing, setIsUnderFencing] = useState(true)
  const [isMapTilesLoaded, setMapTileLoaded] = useState(false)
  let googleMap
  let marker
  let fencedRegion

  const createMarker = () =>
    (marker = new window.google.maps.Marker({
      position: latlng,
      map: googleMap,
      icon: {
        url: CustomMarker,
        size: new window.google.maps.Size(71, 71),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(17, 34),
        scaledSize: new window.google.maps.Size(55, 55),
      },
    }))

  const createGoogleMap = () => {
    googleMap = new window.google.maps.Map(googleMapRef.current, {
      zoom: 16,
      center: latlng,
      disableDefaultUI: true,
      zoomControl: true,
    })
    geoCoderRef.current = new window.google.maps.Geocoder()

    setLatlng({
      lat: 27.704,
      lng: 85.309,
    })
  }

  const addFencing = () => {
    const area = [
      Damak,
      Dharan,
      Dhangadi,
      Baglung,
      Bardaghat,
      Belbari,
      Bhairahawa,
      Bharatpur,
      Biratnagar,
      Birgunj,
      Birtamode,
      Butwal,
      Rajbiraj,
      Gaighat,
      Ghorahi,
      Nepalgunj,
      Hetauda,
      Janakpur,
      Pokhara,
      Siraha,
      Surkhet,
      Tulsipur
    ]
    fencedRegion = new window.google.maps.Polygon({
      paths: [OUTER_RINGROAD, ...area,],
      strokeColor: '#000000',
      strokeOpacity: 0.5,
      strokeWeight: 2,
      fillColor: '#000000',
      fillOpacity: 0.35,
    })

    fencedRegion.setMap(googleMap)
  }

  const isUnderFencingRegion = (lat, lng) => {
    const Latlng = new window.google.maps.LatLng(lat, lng)
    return window.google.maps.geometry.poly.containsLocation(Latlng, fencedRegion)
  }

  useEffect(() => {
    if (googleMap === null || googleMap === undefined) {
      createGoogleMap()
    }
    createMarker()
    mapEventListener()
    addFencing()
  }, [])

  useEffect(() => {
    if (googleMap !== null && googleMap !== undefined) {
      googleMap.addListener('tilesloaded', () => {
        setMapTileLoaded(true);
        createSearchField()
      })
    }

  }, [googleMap])

  const createSearchField = () => {
    // Create the search box and link it to the UI element.
    const input = document.getElementById('pac-input')
    const searchBox = new window.google.maps.places.SearchBox(input)

    googleMap.controls[window.google.maps.ControlPosition.TOP_CENTER].push(
      input,
    )

    // Bias the SearchBox results towards current map's viewport.
    googleMap.addListener('bounds_changed', () => {
      searchBox.setBounds(googleMap.getBounds())
    })

    // Listen for the event fired when the user selects a prediction and retrieve
    // more details for that place.
    searchBox.addListener('places_changed', () => {
      const places = searchBox.getPlaces()

      if (places.length == 0) {
        return
      }
      const bounds = new window.google.maps.LatLngBounds()

      places.forEach((place) => {
        if (!place.geometry || !place.geometry.location) {
          return
        }

        marker.setPosition({
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        })

        setLatlng({
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        })
        if (place.geometry.viewport) {
          bounds.union(place.geometry.viewport)
        } else {
          bounds.extend(place.geometry.location)
        }
      })
      googleMap.fitBounds(bounds)
    })
  }

  const mapEventListener = () => {
    googleMap.addListener('dragend', () => {
      let lat = googleMap.getCenter().lat()
      let lng = googleMap.getCenter().lng()
      setLatlng({lat: lat, lng: lng})
      marker.setPosition({lat: lat, lng: lng})
      let isFenced = isUnderFencingRegion(lat, lng);
      setIsUnderFencing(isFenced);
    })
  }

  useEffect(() => {
    if (latlng && window.google?.maps !== undefined) {
      new window.google.maps.Geocoder().geocode(
        {
          latLng: latlng,
        },
        function (results, status) {
          if (status === window.google.maps.GeocoderStatus.OK) {
            if (results[1]) {
              setAddress(results[2].formatted_address)
            } else {
              alert('No results found')
            }
          } else {
            alert('Geocoder failed due to: ' + status)
          }
        },
      )
    }
  }, [latlng])

  return (
    <div>
      {
        isMapTilesLoaded && <input
          id="pac-input"
          type="text"
          placeholder="Search location"
          className="h-10 px-2 mt-2 ml-2 controls w-90 search"
        />
      }
      <div
        id="google-map"
        ref={googleMapRef}
        style={{width: '100%', height: '100vh'}}
      />
      <div className="buttons">
        <button
          id="close-btn"
          onClick={() => {
            onClose()
          }}
        >
          X
        </button>
        <hr/>
        <button
          id="close-btn"
          onClick={() => {
            onAddressSelected(latlng, address)
          }}
          disabled={!isUnderFencing}
        >
          OK
        </button>
        <div className="control-div">
          <div className="current-location" id="you_location_img"></div>
        </div>
      </div>

      <div className="marker-location">{!isUnderFencing ? "Service Unavailable" : address}</div>
    </div>
  )
}

export default Map
